var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.22 2h-4.44A2 2 0 0 0 6 4v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2v6h-6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18h.01"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14h.01"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12h.01"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16h.01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIcon);
export default __webpack_public_path__ + "static/media/featureIcon.9382a0ffc49e7c120be114a6e03c11a1.svg";
export { ForwardRef as ReactComponent };